import type { ReactNode } from 'react';

export const symbol_books_movies_and_music: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M180-80q-24.75 0-42.37-17.63Q120-115.25 120-140v-551q0-18.67 10.8-33.97Q141.6-740.28 160-747l341-123q29-11 54.5 6.93Q581-845.13 581-813v70h33q24.75 0 42.38 17.62Q674-707.75 674-683v118q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-118H180v543h252q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32Q444.75-80 432-80H180Zm147-663h194v-71l-194 71Zm219 602q-56-56-56-139t56-139q56-56 139-56t139 56q56 56 56 139t-56 139q-56 56-139 56t-139-56Zm105-61 101-65q7-4.5 7-12.75T752-293l-101-65q-8-5-15.5-.7-7.5 4.31-7.5 13.7v130q0 9.39 7.5 13.7 7.5 4.3 15.5-.7Zm-471 62v-543 543Z"
		/>
	</svg>
);
